export default __webpack_public_path__ + "static/media/step3-a.77e7da42.png";